import { createContext, useContext, useEffect, useState } from "react";
import { getPublicSettings } from "../lib/api";

export const DEFAULT_NAV = [
  { id: "nav-music", title: "MUSIC", route: "/music", enabled: true, newTab: false, customUrl: "" },
  { id: "nav-dimensions", title: "DIMENSIONS", route: "/#dimensions", enabled: true, newTab: false, customUrl: "" },
  { id: "nav-visuals", title: "VISUALS", route: "/visuals", enabled: true, newTab: false, customUrl: "" },
  { id: "nav-about", title: "ABOUT", route: "/artist", enabled: true, newTab: false, customUrl: "" },
  { id: "nav-store", title: "STORE", route: "/store", enabled: true, newTab: false, customUrl: "" },
  { id: "nav-supporters", title: "SUPPORTERS", route: "/supporters", enabled: true, newTab: false, customUrl: "" },
];

export const DEFAULT_PROFILE = {
  displayName: "MOTION & MEANING", tagline: "", shortBio: "", aboutBio: "",
  profileImage: "", aboutImage: "", logo: "", website: "",
  contactEmail: "", showContactEmail: false, copyrightText: "",
};

const Ctx = createContext({ settings: null, nav: DEFAULT_NAV, profile: DEFAULT_PROFILE });
export const useSiteSettings = () => useContext(Ctx);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => { getPublicSettings().then(setSettings).catch(() => {}); }, []);

  const nav = (settings?.navigation?.length ? settings.navigation : DEFAULT_NAV)
    .filter((i) => i.enabled !== false);
  const profile = { ...DEFAULT_PROFILE, ...(settings?.artistProfile || {}) };

  return <Ctx.Provider value={{ settings, nav, profile }}>{children}</Ctx.Provider>;
}

/* Renders an artist name with the ampersand accented in gold. */
export function ArtistName({ name, className = "" }) {
  const parts = (name || "MOTION & MEANING").split("&");
  return (
    <span className={className}>
      {parts.map((p, i) => (
        <span key={i}>{i > 0 && <span className="text-gold">&</span>}{p}</span>
      ))}
    </span>
  );
}
